import transformTime12 from "../helpers/transformTime12.js";
import transformTime24 from "../helpers/transformTime24.js";
const controlTime = (self, keepingTime) => {
  const rangeHours = self.HTMLElement.querySelector(`.${self.CSSClasses.timeRange} input[name="hours"]`);
  const rangeMinutes = self.HTMLElement.querySelector(`.${self.CSSClasses.timeRange} input[name="minutes"]`);
  const inputHours = self.HTMLElement.querySelector(`.${self.CSSClasses.timeHours} input[name="hours"]`);
  const inputMinutes = self.HTMLElement.querySelector(`.${self.CSSClasses.timeMinutes} input[name="minutes"]`);
  const btnKeepingTime = self.HTMLElement.querySelector(`.${self.CSSClasses.timeKeeping}`);
  const mouseoverRange = (range, input) => {
    range.addEventListener("mouseover", () => input.classList.add(self.CSSClasses.isFocus));
  };
  const mouseoutRange = (range, input) => {
    range.addEventListener("mouseout", () => input.classList.remove(self.CSSClasses.isFocus));
  };
  const setTime = (e, value, type) => {
    if (type === "hours") {
      self.selectedHours = `${value}`;
    } else if (type === "minutes") {
      self.selectedMinutes = `${value}`;
    }
    self.selectedTime = `${self.selectedHours}:${self.selectedMinutes}${self.selectedKeeping ? ` ${self.selectedKeeping}` : ""}`;
    if (self.actions.changeTime) {
      self.actions.changeTime(e, self.selectedTime, self.selectedHours, self.selectedMinutes, self.selectedKeeping);
    }
    if (self.input && self.HTMLInputElement && self.actions.changeToInput) {
      self.actions.changeToInput(e, self.HTMLInputElement, self.selectedDates, self.selectedTime, self.selectedHours, self.selectedMinutes, self.selectedKeeping);
    }
  };
  const changeRange = (range, input, type, max) => {
    range.addEventListener("input", (e) => {
      let value = Number(e.target.value);
      value = value < 10 ? `0${value}` : `${value}`;
      if (type === "hours" && max === 12) {
        if (Number(e.target.value) < max && Number(e.target.value) > 0) {
          input.value = value;
          self.selectedKeeping = "AM";
          btnKeepingTime.innerText = self.selectedKeeping;
          setTime(e, value, type);
        } else {
          if (Number(e.target.value) === 0) {
            self.selectedKeeping = "AM";
            btnKeepingTime.innerText = "AM";
          } else {
            self.selectedKeeping = "PM";
            btnKeepingTime.innerText = "PM";
          }
          input.value = transformTime12(e.target.value);
          setTime(e, transformTime12(e.target.value), type);
        }
      } else {
        input.value = value;
        setTime(e, value, type);
      }
    });
  };
  const changeInput = (range, input, type, max) => {
    input.addEventListener("change", (e) => {
      const changeInputEl = e.target;
      let value = Number(changeInputEl.value);
      value = value < 10 ? `0${value}` : `${value}`;
      if (type === "hours" && max === 12) {
        if (changeInputEl.value && Number(changeInputEl.value) <= max && Number(changeInputEl.value) > 0) {
          changeInputEl.value = value;
          range.value = transformTime24(value, self.selectedKeeping);
          setTime(e, value, type);
        } else if (changeInputEl.value && Number(changeInputEl.value) < 24 && (Number(changeInputEl.value) > max || Number(changeInputEl.value) === 0)) {
          if (Number(changeInputEl.value) === 0) {
            self.selectedKeeping = "AM";
            btnKeepingTime.innerText = "AM";
          } else {
            self.selectedKeeping = "PM";
            btnKeepingTime.innerText = "PM";
          }
          changeInputEl.value = transformTime12(changeInputEl.value);
          range.value = value;
          setTime(e, transformTime12(changeInputEl.value), type);
        } else {
          changeInputEl.value = self.selectedHours;
        }
      } else if (changeInputEl.value && Number(changeInputEl.value) <= max && Number(changeInputEl.value) >= 0) {
        changeInputEl.value = value;
        range.value = value;
        setTime(e, value, type);
      } else if (type === "hours") {
        changeInputEl.value = self.selectedHours;
      } else if (type === "minutes") {
        changeInputEl.value = self.selectedMinutes;
      }
    });
  };
  mouseoverRange(rangeHours, inputHours);
  mouseoverRange(rangeMinutes, inputMinutes);
  mouseoutRange(rangeHours, inputHours);
  mouseoutRange(rangeMinutes, inputMinutes);
  changeRange(rangeHours, inputHours, "hours", keepingTime === 24 ? 23 : 12);
  changeRange(rangeMinutes, inputMinutes, "minutes", 0);
  changeInput(rangeHours, inputHours, "hours", keepingTime === 24 ? 23 : 12);
  changeInput(rangeMinutes, inputMinutes, "minutes", 59);
  if (!btnKeepingTime)
    return;
  btnKeepingTime.addEventListener("click", (e) => {
    if (btnKeepingTime.innerText.includes("AM")) {
      self.selectedKeeping = "PM";
    } else {
      self.selectedKeeping = "AM";
    }
    rangeHours.value = transformTime24(self.selectedHours, self.selectedKeeping);
    setTime(e, self.selectedHours, "hours");
    btnKeepingTime.innerText = self.selectedKeeping;
  });
};
export {
  controlTime as default
};
